var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRxSidemenuKnowledgeCentre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2840_9218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 19.0007C4.36817 18.2108 5.92017 17.7949 7.5 17.7949C9.07983 17.7949 10.6318 18.2108 12 19.0007C13.3682 18.2108 14.9202 17.7949 16.5 17.7949C18.0798 17.7949 19.6318 18.2108 21 19.0007",
    stroke: "#767679",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.00069C4.36817 5.21078 5.92017 4.79492 7.5 4.79492C9.07983 4.79492 10.6318 5.21078 12 6.00069C13.3682 5.21078 14.9202 4.79492 16.5 4.79492C18.0798 4.79492 19.6318 5.21078 21 6.00069",
    stroke: "#767679",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6V19",
    stroke: "#767679",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6V19",
    stroke: "#767679",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6V19",
    stroke: "#767679",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2840_9218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxSidemenuKnowledgeCentre);
export default __webpack_public_path__ + "static/media/rx-sidemenu-knowledge-centre.c6fff1b4796c430d499acd754c9002a9.svg";
export { ForwardRef as ReactComponent };